import styled from "styled-components";
import { colors } from "colors";

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  
  font-size: 14px;
  color: ${colors.charcoalGrey};
  
  .react-select__control {
    cursor: pointer;
    border: 1px solid ${colors.silver};
  }
  
  .data-error {
    .react-select__control {
      border: 1px solid ${colors.strawberry};
    }
  }
  
  .react-select__input {
    input {
      margin: 0;
    }
  }
  
  .react-select__placeholder {
    color: ${colors.silver};
  }
  
  .react-select__value-container {
    flex-wrap: nowrap;
  }
`;

export const Label = styled.label`
  color: ${colors.slateGrey};
 
  &[required] {
    ::after {
      content: " *";
      color: ${colors.strawberry};
    }
  }
`;

export const SingleValueWrapper = styled.span`
  display: inline;
  white-space: nowrap;
`;


export const OptionWrapper = styled.div`
  padding: 12px 16px;
  cursor: pointer;
  
  p {
    margin: 0;
  }

  div {
    display: flex;
    font-size: 12px;
    > * {
      ::after {
        content: '·';
        font-weight: bold;
        margin: 4px;
      }

      &:last-child::after {
        content: '';
      }
    }
  }
  
  :hover {
    background-color: ${colors.lightGrey};
  }
`;


